import {
  AppContext,
  CountryListDropDown,
  StateListDropDown,
  getCompanyInfoHook,
  getTranslatedText
} from '@nile/components/src';
import {
  Button,
  ButtonGroup,
  Page,
  TextField,
  TextStyle
} from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const CreateAddressContainer = (props) => {
  const intl = useIntl();
  const appContext = useContext(AppContext);
  const { company } = appContext;
  const [siteName, setSiteName] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [addressLine3, setAddressLine3] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [currentCountry, setCurrentCountry] = useState(
    company?.hqSite?.address?.countryCode || null
  );
  const [stateCode, setStateCode] = useState(
    company?.hqSite?.address?.stateCode || null
  );

  const handleStateChange = (field, value) => {
    setStateCode(value);
  };

  const onCancel = () => {
    props?.onCancel();
  };

  const onSave = () => {
    props?.onSave({
      name: siteName.trim(),
      line1: addressLine1.trim(),
      line2: addressLine2.trim(),
      line3: addressLine3.trim(),
      postalCode: postalCode.trim(),
      city: city.trim(),
      countryCode: currentCountry,
      stateCode: stateCode
    });
  };
  return (
    // <div className="h99">
    <Page
      title={getTranslatedText(intl, 'address.form.title')}
      subtitle={getTranslatedText(intl, 'address.form.subtitle')}
      contentHeight="120px"
      fullWidth
      primaryAction={
        <ButtonGroup>
          <Button plainSecondary onClick={onCancel}>
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button
            primary
            onClick={onSave}
            loading={props?.saveLoading}
            disabled={isEmpty(siteName.trim())}
          >
            <FormattedMessage id="common.save" />
          </Button>
        </ButtonGroup>
      }
    >
      <div>
        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="address.form.address.name.label" />
          </TextStyle>
          <div className="mt-5">
            <TextField
              value={siteName}
              onChange={(value) => setSiteName(value)}
              placeholder={getTranslatedText(
                intl,
                'address.form.address.name.placeholder'
              )}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.line1" />
          </TextStyle>
          <div className="mt-5">
            <TextField
              value={addressLine1}
              onChange={(value) => setAddressLine1(value)}
              placeholder={getTranslatedText(intl, 'admin.mspDetails.line1.pl')}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.line2" />
          </TextStyle>
          <div className="mt-5">
            <TextField
              value={addressLine2}
              onChange={(value) => setAddressLine2(value)}
              placeholder={getTranslatedText(intl, 'admin.mspDetails.line2.pl')}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.line3" />
          </TextStyle>
          <div className="mt-5">
            <TextField
              value={addressLine3}
              onChange={(value) => setAddressLine3(value)}
              placeholder={getTranslatedText(intl, 'admin.mspDetails.line3.pl')}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.postalCode" />
          </TextStyle>
          <div className="mt-5">
            <TextField
              value={postalCode}
              onChange={(value) => setPostalCode(value)}
              placeholder={getTranslatedText(
                intl,
                'admin.mspDetails.postalCode.pl'
              )}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.city" />
          </TextStyle>
          <div className="mt-5">
            <TextField
              value={city}
              onChange={(value) => setCity(value)}
              placeholder={getTranslatedText(intl, 'admin.mspDetails.city.pl')}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.country" />
          </TextStyle>
          <div className="mt-5">
            <CountryListDropDown
              countryCode={currentCountry?.isoCode || currentCountry}
              placeholderkey="client.new.siteInfo.country.pl"
              labelkey="client.new.siteInfo.country"
              handleFunction={setCurrentCountry}
            />
          </div>
        </div>

        <div className="mb-15">
          <TextStyle>
            <FormattedMessage id="admin.mspDetails.state" />
          </TextStyle>
          <div className="mt-5">
            <StateListDropDown
              stateCode={stateCode}
              countryCode={currentCountry?.isoCode || currentCountry}
              placeholderkey="client.new.siteInfo.state.pl"
              labelkey="client.new.siteInfo.state"
              handleFunction={handleStateChange}
              handleFunctionArgs={['stateCode']}
            />
          </div>
        </div>
      </div>
    </Page>
    // </div>
  );
};

export default CreateAddressContainer;
